
import { type Language } from "@/contexts/LanguageContext";

// Mappage des codes de langue aux clés de traduction
export const languageMappings: Record<Language, string> = {
  fr: "french",
  en: "english",
  es: "spanish",
  it: "italian",
  de: "german",
  nl: "dutch"
};

// Détecte la langue du navigateur et la mappe à l'une de nos langues prises en charge
export const detectBrowserLanguage = (): Language => {
  const browserLang = navigator.language.split('-')[0];
  
  // Mappez les codes de langue du navigateur à nos codes de langue
  const langMap: Record<string, Language> = {
    fr: "fr",
    en: "en",
    es: "es",
    it: "it",
    de: "de",
    nl: "nl"
  };
  
  return langMap[browserLang] || "fr";
};
